import {
  usePortalPasswordResetMutation,
  useRequestPasswordResetMutation,
} from "@dashboard/graphql";
import useNavigator from "@dashboard/hooks/useNavigator";
import { commonMessages } from "@dashboard/intl";
import { extractMutationErrors } from "@dashboard/misc";
import { isPortalHost } from "@dashboard/portal/portalHost";
import { useState } from "react";
import { useIntl } from "react-intl";

import ResetPasswordPage, { ResetPasswordPageFormData } from "../components/ResetPasswordPage";
import { passwordResetSuccessUrl } from "../urls";
import { getNewPasswordResetRedirectUrl } from "../utils";

const ResetPasswordView = () => {
  const [error, setError] = useState<string>();
  const navigate = useNavigator();
  const intl = useIntl();
  const [requestPasswordReset, requestPasswordResetOpts] = useRequestPasswordResetMutation({
    onCompleted: data => {
      if (data?.requestPasswordReset?.errors.length === 0) {
        navigate(passwordResetSuccessUrl);
      } else {
        setError(intl.formatMessage(commonMessages.somethingWentWrong));
      }
    },
  });
  // On the employee portal the identifier may be a username and the link goes
  // to the colaborador's personal email (backend portalPasswordReset).
  const [portalPasswordReset, portalPasswordResetOpts] = usePortalPasswordResetMutation({
    onCompleted: data => {
      if (data?.portalPasswordReset?.errors.length === 0) {
        navigate(passwordResetSuccessUrl);
      } else {
        setError(intl.formatMessage(commonMessages.somethingWentWrong));
      }
    },
  });
  const handleSubmit = (data: ResetPasswordPageFormData) =>
    isPortalHost()
      ? extractMutationErrors(
          portalPasswordReset({
            variables: {
              identifier: data.email,
              redirectUrl: getNewPasswordResetRedirectUrl(),
            },
          }),
        )
      : extractMutationErrors(
          requestPasswordReset({
            variables: {
              email: data.email,
              redirectUrl: getNewPasswordResetRedirectUrl(),
            },
          }),
        );

  return (
    <ResetPasswordPage
      disabled={requestPasswordResetOpts.loading || portalPasswordResetOpts.loading}
      error={error as string}
      onSubmit={handleSubmit}
    />
  );
};

ResetPasswordView.displayName = "ResetPasswordView";
export default ResetPasswordView;
